import { LAYOUTS, POSITION } from '@voltmoney/types';
import { WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { CameraConfirmAction, GoBackAction, photoVerification, retakePhoto, needHelp, successVerification, onModalCloseAction } from './actions';
import { getContactUsDetails, horizontalStepperRepo } from '../../../configs/utils';
import { Platform } from "react-native";
import SharedPropsService from "../../../SharedPropsService";
export const template = (stepper, height, photo, isImageUploaded, isFromJupiter, contactUsDetails) => ({
    layout: {
        id: ROUTE.KYC_PHOTO_VERIFICATION,
        type: LAYOUTS.LIST,
        widgets: [
            Platform.OS === "ios" ? { id: "spaceXXL", type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP } : {},
            { id: "kycPhotoInit", type: WIDGET.KYC_PHOTO_INIT }
        ],
    },
    datastore: {
        kycPhotoInit: {
            height: height,
            stepperData: stepper,
            takePhotoAction: {
                type: ACTION.CAMERA_ACTION,
                routeId: ROUTE.KYC_PHOTO_VERIFICATION,
                payload: {}
            },
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.KYC_PHOTO_VERIFICATION,
                payload: {}
            },
            takePhotoAgainAction: {
                type: ACTION.RETAKE_PHOTO,
                routeId: ROUTE.KYC_PHOTO_VERIFICATION,
                payload: {}
            },
            finalPhotoVerifyAction: {
                type: ACTION.FINAL_PHOTO_VERIFY,
                routeId: ROUTE.KYC_PHOTO_VERIFICATION,
                payload: {}
            },
            previewImage: photo,
            isImageUploaded: isImageUploaded,
            loading: false,
            kycPhotoUploadSuccess: false,
            continueToNextStepAction: {
                type: ACTION.CONTINUE_TO_NEXT_STEP,
                routeId: ROUTE.KYC_PHOTO_VERIFICATION,
                payload: {}
            },
            needHelpAction: {
                type: ACTION.NEED_HELP,
                routeId: ROUTE.KYC_PHOTO_VERIFICATION,
                payload: {}
            },
            isFromJupiter: isFromJupiter,
            contactUsDetails: contactUsDetails,
            onModalCloseAction: {
                type: ACTION.ON_MODAL_CLOSE_ACTION,
                routeId: ROUTE.KYC_PHOTO_VERIFICATION,
                payload: {}
            }
        },
    },
});
export const cameraOpenMF = {
    onLoad: async ({ getHeight, network }, { photo, isImageUploaded }) => {
        const imageUploaded = isImageUploaded ? isImageUploaded : false;
        const stepper = await horizontalStepperRepo(network);
        const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER";
        const contactUsDetails = await getContactUsDetails();
        return Promise.resolve(template(stepper, getHeight(), photo, imageUploaded, isFromJupiter, contactUsDetails));
    },
    actions: {
        [ACTION.CAMERA_ACTION]: CameraConfirmAction,
        [ACTION.GO_BACK]: GoBackAction,
        [ACTION.RETAKE_PHOTO]: retakePhoto,
        [ACTION.FINAL_PHOTO_VERIFY]: photoVerification,
        [ACTION.CONTINUE_TO_NEXT_STEP]: successVerification,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.ON_MODAL_CLOSE_ACTION]: onModalCloseAction,
    },
    clearPrevious: true,
};
